import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import { DashboardKnowledgeTestAnalysisFilter, DashboardKnowledgeTestAnalysisSummaryColumn, TopicSuggestionDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { KnowledgeTestAnalysisAnsweredGraph } from "views/Dashboards/KnowledgeTestAnalysisDashboard/KnowledgeTestAnalysisAnswered";
import KnowledgeTestAnalysisFilter from "views/Dashboards/KnowledgeTestAnalysisDashboard/KnowledgeTestAnalysisFilter";
import KnowledgeTestAnalysisMissing from "views/Dashboards/KnowledgeTestAnalysisDashboard/KnowledgeTestAnalysisMissing";
import { KnowledgeTestAnalysisPublishedGraph } from "views/Dashboards/KnowledgeTestAnalysisDashboard/KnowledgeTestAnalysisPublished";
import KnowledgeTestAnalysisTiles from "views/Dashboards/KnowledgeTestAnalysisDashboard/KnowledgeTestAnalysisTiles";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    tile: DashboardKnowledgeTestAnalysisSummaryColumn;
    filter: DashboardKnowledgeTestAnalysisFilter;
    selectedTopic: TopicSuggestionDto;
}

interface IProps {
}

type Props = IProps & WithSnackbar & WithTranslation & RouteComponentProps<any, any, any>;

/////////////////////////////////////////////////////////////////////////////////////

class KnowledgeTestAnalysisDashboard extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = this.calculateInitialState();
    }

    ///
    private calculateInitialState() {
        const hash: DashboardKnowledgeTestAnalysisSummaryColumn = this.props.location.hash
            ? DashboardKnowledgeTestAnalysisSummaryColumn[this.props.location.hash.substr(1)]
            : null;

        const s = this.props.location.state;

        return {
            tile: hash || DashboardKnowledgeTestAnalysisSummaryColumn.Published,
            filter: s != null && s.filter != null ? s.filter : null,
            selectedTopic: s != null && s.selectedTopic != null ? s.selectedTopic : null,
        };
    }

    ///
    private handleSelectTopic = (topicId: string, name: string, thumbnailUrl: string) => {

        this.updateHistory(this.state.tile, { key: topicId, label: name, thumbnailUrl: thumbnailUrl } as TopicSuggestionDto);

        this.props.snackbar.showMessage(this.props.t("Views.Dashboards.KnowledgeTestAnalysis.Index.FilteringTopic", { name: name }));
    };

    ///
    private getFilter(): DashboardKnowledgeTestAnalysisFilter {
        const { selectedTopic } = this.state;

        return {
            topicId: selectedTopic == null ? null : selectedTopic.key,
            topicName: selectedTopic == null ? null : selectedTopic.label,
            topicThumbnailUrl: selectedTopic == null ? null : selectedTopic.thumbnailUrl,
        };
    }

    ///
    private updateHistory(tile: DashboardKnowledgeTestAnalysisSummaryColumn, selectedTopic: TopicSuggestionDto) {
        this.props.history.replace(`#${DashboardKnowledgeTestAnalysisSummaryColumn[tile]}`, {
            tile: tile,
            selectedTopic: selectedTopic
        });
    }

    ///
    private checkForUpdateState(prevProps: Props) {

        if (prevProps.location.hash != this.props.location.hash || prevProps.location.state != this.props.location.state) {
            this.setState({
                ...this.calculateInitialState()
            });
        }
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        this.checkForUpdateState(prevProps);
    }

    ///
    public render() {
        const { selectedTopic, tile } = this.state;

        const filter = this.getFilter();

        return (
            <>
                <KnowledgeTestAnalysisFilter
                    {...this.props}
                    selectedTopic={selectedTopic}
                    disabled={tile == DashboardKnowledgeTestAnalysisSummaryColumn.MissingTests}
                    onFilterChange={
                        (selectedTopic) => {
                            this.updateHistory(tile, selectedTopic);
                        }
                    }
                />

                <KnowledgeTestAnalysisTiles
                    {...this.props}
                    activeTile={tile}
                    filter={filter}
                    onChange={
                        (newTile) => {
                            this.updateHistory(newTile, selectedTopic);
                        }
                    }
                />

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="success">
                        {
                            tile == DashboardKnowledgeTestAnalysisSummaryColumn.Published
                                ? <KnowledgeTestAnalysisPublishedGraph
                                    {...this.props}
                                    filter={filter}
                                    onSelectTopic={this.handleSelectTopic}
                                />
                                : tile == DashboardKnowledgeTestAnalysisSummaryColumn.Answered
                                    ? <KnowledgeTestAnalysisAnsweredGraph
                                        {...this.props}
                                        filter={filter}
                                        onSelectTopic={this.handleSelectTopic}
                                    />
                                    : <KnowledgeTestAnalysisMissing
                                        {...this.props}
                                        filter={filter}
                                    />
                        }
                    </MuiPaper>
                </MuiContainer>
            </>
        );
    }
}

export default withSnackbar(withTranslation()(KnowledgeTestAnalysisDashboard));